export default "__VITE_ASSET__D90_G$2P__"